import { APIDomain } from 'models/API';
import { Storage } from 'repositories/Storage';
import { Result, Success } from 'types';
import { Device } from 'models/Device/type';
import { ApplicationError } from 'models/Error';
import { DeviceDomain } from 'models/Device';
import { saml } from 'repositories/saml';

export class SAMLDomain {
  static async loginURL(
    name: string
  ): Promise<Result<string, ApplicationError>> {
    try {
      const response = await saml.setting(name);
      let url = `${APIDomain.origin()}/saml/sso/${
        response.results.saml_setting_ulid
      }?context=ios_spa_login`;

      const uid = await Storage.get('iphone_uid');
      if (uid) {
        url += `&device_token=${uid}`;
      }

      return new Success(url);
    } catch (e) {
      // `SAML authentication disabled` or `no enterprise found`
      return ApplicationError.handleForRepositoryError(e, [400, 404]);
    }
  }

  static async login(
    onetimeToken: string
  ): Promise<Result<Device | null, ApplicationError>> {
    const uid = await Storage.get('iphone_uid');

    try {
      if (uid) {
        const authorizationToken = await saml.authorizationToken(onetimeToken);
        await Storage.save('token', authorizationToken);
        return new Success(await DeviceDomain.restore());
      } else {
        const iphoneRegistrationToken = await saml.iphoneRegistrationToken(
          onetimeToken
        );

        await DeviceDomain.saveIphoneRegistrationToken(iphoneRegistrationToken);
        return new Success({
          iphoneRegistrationToken,
        });
      }
    } catch (e) {
      return ApplicationError.handleForRepositoryError(e);
    }
  }
}
